// import React, { useState } from 'react';
// import { styled } from 'styled-components';
// import PopupModal from '../PopupModal/PopupModal';
// import userDeleteIcon from '../../public/userDeleteIcon.png';
// import { useAuth0 } from '@auth0/auth0-react';
// import { Img } from 'react-image';
// import { useTranslation } from 'react-i18next';

// export default function DeleteUserDataButton() {
//   const { user } = useAuth0();
//   const userMail = user.email;
//   const _id = user.email;
//   const { t } = useTranslation();

//   const [modalOpen, setModalOpen] = useState(false);
//   function closeModal() {
//     setModalOpen(false);
//   }

//   async function handleDelete() {
//     try {
//       const response = await fetch(
//         `/api/savedInsulinDatas/[id]?userMail=${userMail}`,
//         {
//           method: 'DELETE',
//         }
//       );
//       await fetch('/api/insulinFactor/' + _id, {
//         method: 'DELETE',
//       });
//       await fetch('/api/correctionFactor/' + _id, {
//         method: 'DELETE',
//       });
//       if (response.ok) {
//         console.log('Daten wurden erfolgreich gelöscht.');
//       } else {
//         console.error('Fehler beim Löschen der Daten.');
//       }
//       closeModal();
//     } catch (error) {
//       console.error('Fehler beim Löschen der Daten:', error);
//     }
//     setModalOpen(false);
//   }

//   const handleCancel = () => {
//     setModalOpen(false);
//   };

//   return (
//     <>
//      {modalOpen && (
//         <PopupModal onClose={handleCancel} onConfirm={handleDelete} />
//       )}
//     <PopupWrapper>
//       <DeleteButton onClick={() => setModalOpen(true)}>
//         <UserDeleteIcon src={userDeleteIcon} alt="UserDeleteIcon" />
//         {t('deleteUserData')}
//       </DeleteButton>
     
//     </PopupWrapper>
//     </>
//   );
// }

// const PopupWrapper = styled.div`
//   display: grid;
//   justify-content: start;
//   margin: 0.4rem 0.4rem 0.4rem 0;
// `;

// const DeleteButton = styled.button`
//   background: none;
//   border: none;
//   border-radius: 5px;
//   width: 9rem;
//   color: hotpink;
//   font-size: 1rem;
//   cursor: pointer;
// `;

// const UserDeleteIcon = styled(Img)`
//   background: transparent;
//   margin: 1.5rem 1rem 0 0.7rem;
// `;


import React, { useState } from 'react';
import { styled } from 'styled-components';
import PopupModal from '../PopupModal/PopupModal';
import userDeleteIcon from '../../public/userDeleteIcon.png';
import { useAuth0 } from '@auth0/auth0-react';
import { Img } from 'react-image';
import { useTranslation } from 'react-i18next';

export default function DeleteUserDataButton() {
  const { user } = useAuth0();
  const userMail = user?.email;
  const { t } = useTranslation();

  const [modalOpen, setModalOpen] = useState(false);
  function closeModal() {
    setModalOpen(false);
  }

async function handleDelete() {
  try {
    const response = await fetch(
      `https://insulinapp.de/api/deleteUserData.php?userMail=${user.email}`,
      { method: 'DELETE' }
    );

    if (response.ok) {
      console.log('Alle Benutzerdaten erfolgreich gelöscht.');

      // Auth0-Logout
      window.localStorage.clear();
      window.location.href = '/'; // oder auth0 logout redirect
    } else {
      console.error('Fehler beim Löschen der Daten.');
    }
  } catch (error) {
    console.error('Fehler beim Löschen der Daten:', error);
  }

  setModalOpen(false);
}


  const handleCancel = () => {
    setModalOpen(false);
  };

  return (
    <>
      {modalOpen && (
        <PopupModal onClose={handleCancel} onConfirm={handleDelete} />
      )}
      <PopupWrapper>
        <DeleteButton onClick={() => setModalOpen(true)}>
          <UserDeleteIcon src={userDeleteIcon} alt="UserDeleteIcon" />
          {t('deleteUserData')}
        </DeleteButton>
      </PopupWrapper>
    </>
  );
}

const PopupWrapper = styled.div`
  display: grid;
  justify-content: start;
  margin: 0.4rem 0.4rem 0.4rem 0;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  border-radius: 5px;
  width: 9rem;
  color: hotpink;
  font-size: 1rem;
  cursor: pointer;
`;

const UserDeleteIcon = styled(Img)`
  background: transparent;
  margin: 1.5rem 1rem 0 0.7rem;
`;
